/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type { GetAllParams, PagedResponseAssetResponse } from '../models';

export type getAllResponse200 = {
    data: PagedResponseAssetResponse;
    status: 200;
};

export type getAllResponse400 = {
    data: void;
    status: 400;
};

export type getAllResponse500 = {
    data: void;
    status: 500;
};

export type getAllResponseSuccess = getAllResponse200 & {
    headers: Headers;
};

export type getAllResponseError = (getAllResponse400 | getAllResponse500) & {
    headers: Headers;
};

export type getAllResponse = getAllResponseSuccess | getAllResponseError;

export const getGetAllUrl = (params?: GetAllParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/assets?${stringifiedParams}` : `/api/v1/assets`;
};

export const getAll = async (
    params?: GetAllParams,
    options?: RequestInit
): Promise<getAllResponse> => {
    const res = await fetch(getGetAllUrl(params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getAllResponse['data'];

    return { data, headers: res.headers, status: res.status } as getAllResponse;
};
